import {
  createPlugin,
  createRoutableExtension,
} from '@backstage/core-plugin-api';

import { rootRouteRef } from './routes';

export const maturityPlugin = createPlugin({
  id: 'maturity',
  routes: {
    root: rootRouteRef,
  },
});

export const SystemMaturityPage = maturityPlugin.provide(
  createRoutableExtension({
    name: 'SystemMaturityPage',
    component: () =>
      import('./components/SystemMaturityPage').then(m => m.SystemMaturityPage),
    mountPoint: rootRouteRef,
  }),
);

export const ComponentMaturityPage = maturityPlugin.provide(
  createRoutableExtension({
    name: 'ComponentMaturityPage',
    component: () =>
      import('./components/ComponentMaturityPage').then(m => m.ComponentMaturityPage),
    mountPoint: rootRouteRef,
  }),
);
